import { Theme } from '@material-ui/core/styles';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette }: Theme) {
    return {
        dialogPaper: {
            backgroundColor: palette.type === 'dark' ? 'rgba(255, 255, 255, 0.75)' : 'rgba(0, 0, 0, 0.15)',
            position: 'absolute !important' as 'absolute' ,
            height: '100%',
            width: '100%',
        },
    };
}
